<template>
  <div>
    <div v-show="isLoading" class="noStatusReportsYet">There are no status reports yet</div>
    <div v-show="!isLoading" id="gridStatusOverview">
      <div v-for="(key, name) in mappedStatusReportContent" :key="name">
        <div class="subTitles">{{ $t(localeConsts[name]) }}</div>
        <div class="status">
          {{ capitalizeFirstLetter(mapIntStatusLevelToString(mappedStatusReportContent[name])) }}
          <div
            :class="{
              dot: true,
              redDot: mappedStatusReportContent[name] == 2,
              orangeDot: mappedStatusReportContent[name] == 1,
              greenDot: mappedStatusReportContent[name] == 0
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../../../axios'

import mapGettersMixin from '../../../mixins/mapGettersMixin'
import { trafficLightsMixin } from '../../../mixins/trafficLightsMixin'

export default {
  name: 'StatusOverview',

  mixins: [mapGettersMixin, trafficLightsMixin],
  data() {
    return {
      localeConsts: {
        overallStatus: 'STATUSREPORTS.OVERALL_STATUS',
        workload: 'STATUSREPORTS.WORK_LOAD',
        quality: 'STATUSREPORTS.QUALITY',
        teamSpirit: 'STATUSREPORTS.TEAM_SPIRIT',
        schedule: 'STATUSREPORTS.SCHEDULE',
        budget: 'STATUSREPORTS.BUDGET',
        riskIdentified: 'STATUSREPORTS.RISK_IDENTIFIED'
      },
      statusReportContent: {}
    }
  },
  computed: {
    isLoading() {
      return this.statusReportContent.id === undefined ? true : false //eslint-disable-line
    },
    mappedStatusReportContent() {
      return {
        overallStatus: this.statusReportContent.global_status_level,
        workload: this.statusReportContent.workload_level,
        quality: this.statusReportContent.quality_level,
        teamSpirit: this.statusReportContent.team_spirit_level,
        schedule: this.statusReportContent.schedule_level,
        budget: this.statusReportContent.budget_level
      }
    }
  },
  mounted() {
    this.fetchLatestStatusReport()
  },
  methods: {
    async fetchLatestStatusReport() {
      const responseProjectId = await this.getProjectId
      const params = {
        params: {
          project_id: responseProjectId
        }
      }
      const response = await axios.get('status-reports', params)
      const sorted = response.data.sort((a, b) => new Date(b.creation_date) - new Date(a.creation_date))
      this.statusReportContent = sorted[0]
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    }
  }
}
</script>

<style scoped>
#gridStatusOverview {
  display: grid;
  grid-template: 1fr 1fr 1fr / 1fr 1fr;
  grid-column-gap: 80px;
  grid-row-gap: 13%;
}

.subTitles {
  color: #8b69a9;
  font-weight: 600;
  margin-right: 15px;
  display: block;
}

.noStatusReportsYet {
  display: flex;
  justify-content: center;
  padding-top: 120px;
}

.status {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.dot {
  border-radius: 50%;
  height: 20px;
  width: 20px;
  margin-left: 10px;
}

.redDot {
  background-color: red;
}

.orangeDot {
  background-color: orange;
}

.greenDot {
  background-color: rgb(0, 190, 0);
}
</style>
